import { css } from 'styled-components';
import { NumColumns } from '../constants';

export const columnWidth = (num) => `${((num / NumColumns) * 100).toFixed(5)}%`;

export const columnEnd = css`
    &:last-child:last-child:not(:first-child) {
        float: left;
    }
`;

export const columnInline = css`
    &:last-child:last-child:not(:first-child) {
        float: right;
    }
`;

export const columnOffset = (cols) => css`
    margin-left: ${columnWidth(cols)};
`;

export const columnSize = (cols) => css`
    width: ${columnWidth(cols)};
`;

const column = css`
    float: left;
    padding-left: 0;
    padding-right: 0;

    &:last-child:not(:first-child) {
        float: right;
    }
`;

export default column;
